import { useLocale } from '../../application/i18n/LocaleProvider';
import { ShareIcon } from '../chrome/BrandIcons';

/**
 * The card's one action (SPEC-025 D-15).
 *
 * It used to be *Add to my garden*, which is the action the approved reference
 * pins to the foot of a plant PAGE. A page is a place a reader has arrived at and
 * is deciding about; a card in a deck is a plant they are being shown. The
 * decision has not been reached yet, and the thing a reader wants to do with a
 * plant they have just been shown is pass it on.
 *
 * So the primary is sharing, and saving keeps the heart it has always had in the
 * band above — FR-06's save action is still one press away, and `plant-detail`
 * has always held that the heart and this row are two affordances over one
 * membership list. They are now two affordances over two different things, which
 * is why only one of them is a full-width button.
 *
 * Sticky inside the scroll container rather than fixed to the viewport: fixed
 * elements and the iOS URL bar disagree about where the bottom is, and this route
 * has no tab bar to hide behind. On a collapsed card it is simply the card's last
 * row — there is nothing to scroll past it, so nothing for it to stick to.
 */
export default function PlantCardAction({ onShare, shareResult }) {
    const { t } = useLocale();

    return (
        <div className="card-action">
            {/* The share sheet is the OS's and says its own piece; the clipboard
                fallback is silent, so this is the only sign anything happened. */}
            <p className="card-action__status" role="status">
                {shareResult === 'copied' ? t('plants.detail.shareCopied') : ''}
            </p>
            <button
                type="button"
                className="button button--primary card-action__button"
                onClick={onShare}
            >
                <ShareIcon size={22} />
                {/* Its OWN words, unlike the glyph over the picture. The glyph
                    is a generic affordance and says what it does —
                    `plants.detail.share`, "Share this plant". This is the card's
                    one invitation and names who it is for, which is a different
                    sentence and earns a key of its own.

                    German and Hungarian take the plural: the neutral singular is
                    gendered in one and stilted in the other, and "with friends"
                    is what either language actually says. */}
                {t('plants.detail.shareWithFriend')}
            </button>
        </div>
    );
}
